import React, {} from "react";

import { useTranslation } from "react-i18next";
import { formatAccountNumber } from "../../helpers/formatters";
import { Input, InputValidation } from "./";

interface AccountNumberProps {
    onBlur: (e: React.FormEvent<HTMLInputElement>) => void;
    setFieldValue: (field: string, value: string) => void;
    disabled?: boolean;
    validation?: InputValidation;
    autoComplete?: string;
    name: string;
    value: string;
    country: string;
    required?: boolean;
}

const AccountNumber = (props: AccountNumberProps) => {
    const { name, setFieldValue } = props;

    const { t } = useTranslation();

    const placeholder = t("components.account_number.placeholder", {
        context: props.country,
    });
    return (
        <Input
            key={props.country}
            label={t("components.account_number.label")}
            placeholder={placeholder!}
            options={{}}
            type="text"
            name={props.name}
            value={props.value}
            onChange={(event) => setFieldValue(name, event.currentTarget.value)}
            onBlur={(e) => {
                setFieldValue(
                    name,
                    formatAccountNumber(props.country, e.currentTarget.value),
                );
                props.onBlur(e);
            }}
            validation={props.validation}
            disabled={props.disabled}
            required={props.required}
        />
    );
};

export default AccountNumber;
